import { createOrderItemQuantitySchema } from '@vs-shop/schemas/orderItemQuantity';
import { Exit, Schema } from 'effect';

export {
  canDecrementQuantity,
  canIncrementQuantity,
  checkAvailable,
  getAvailableQuantityWithCartInMind,
  getMaxOrderable,
  getMaxOrderableInf,
  isMaxOrderableExceededInCart,
  shouldAddToCartButtonBeDisabled,
} from '@vs-shop/domain/stock/stockValidation';
export type { MaxOrderable } from '@vs-shop/domain/stock/stockValidation';

export const validateQuantity = (input: string, max: number, min = 1) => {
  const schema = createOrderItemQuantitySchema(min, max);
  const result = Schema.decodeExit(schema)(input);

  return Exit.match(result, {
    onFailure: () => min,
    onSuccess: (value) => value,
  });
};
